export default __webpack_public_path__ + "static/media/parent.556ff13d.png";